import { useTranslation } from "react-i18next";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useSelector, useDispatch } from "react-redux";
import { loginUser, userSelector, clearState } from "../../User/UserSlice";
import toast from "react-hot-toast";
import { useHistory } from "react-router-dom";
import ReCAPTCHA from "react-google-recaptcha";
import { Link } from "react-router-dom";
import {
  FaArrowRight,
  FaEye,
  FaEyeSlash,
  FaLock,
  FaUser,
} from "react-icons/fa";

const Login = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const { register, errors, handleSubmit } = useForm();
  const { isFetching, isSuccess, isError, errorMessage } =
    useSelector(userSelector);

  console.log("isSuccess");
  console.log(isSuccess);

  const onSubmit = (data) => {
    dispatch(loginUser(data));
  };

  useEffect(() => {
    return () => {
      dispatch(clearState());
    };
  }, [dispatch]);

  useEffect(() => {
    if (isError) {
      toast.error(errorMessage);
      dispatch(clearState());
    }

    if (isSuccess) {
      dispatch(clearState());
      history.push("/otp");
    }
  }, [isError, isSuccess, dispatch, history, errorMessage]);

  const [isCaptchaVerified, setIsCaptchaVerified] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleCaptchaVerify = () => {
    setIsCaptchaVerified(true);
  };

  return (
    <div className="landing-login">
      <form onSubmit={handleSubmit(onSubmit)} method="POST">
        <div className="landing-field">
          <label htmlFor="login-email">{t("email_or_phone")}</label>
          <div className="input-shell">
            <FaUser aria-hidden="true" />
            <input
              name="email"
              id="login-email"
              type="text"
              ref={register({ required: true })}
              required
              className="form-control"
              placeholder={t("enter_email_or_phone")}
              aria-describedby="numberHelp"
            />
          </div>
        </div>
        <div className="landing-field">
          <label htmlFor="login-password">{t("password_label")}</label>
          <div className="input-shell">
            <FaLock aria-hidden="true" />
            <input
              name="password"
              type={showPassword ? "text" : "password"}
              ref={register({ required: true })}
              autoComplete="current-password"
              required
              className="form-control"
              id="login-password"
              placeholder={t("enter_your_password")}
            />
            <button
              type="button"
              onClick={() => setShowPassword(!showPassword)}
              aria-label={showPassword ? "Hide password" : "Show password"}
            >
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </button>
          </div>
        </div>
        <Link className="forgot-password" to="/help">
          {t("forgot_password")}
        </Link>
        <div className="landing-captcha">
          <ReCAPTCHA
            sitekey="6LdDLJEpAAAAAH4yHx5GfRDcvHzvaKkwx6fMtTdT"
            onChange={handleCaptchaVerify}
          />
        </div>
        <button
          type="submit"
          className="landing-submit"
          disabled={!isCaptchaVerified || isFetching}
          aria-busy={isFetching}
        >
          {isFetching ? (
            <>
              <span className="button-spinner" aria-hidden="true" /> {t("signing_in")}
            </>
          ) : (
            <>
              {t("sign_in_btn")} <FaArrowRight aria-hidden="true" />
            </>
          )}
        </button>
        <div id="emailHelp" className="landing-signup-note">
          <span>{t("dont_have_account_note")}</span>
          <Link to="/getstarted-signup">
            {t("create_account_btn")} <FaArrowRight aria-hidden="true" />
          </Link>
        </div>
      </form>
    </div>
  );
};

export default Login;
